import { Loader } from 'braid-design-system';
import { format } from 'date-fns';
import type React from 'react';

import { useQueryJobExpiryDate } from 'src/hooks/useQueryJobExpiryDate';

import { UpdateExpiryDateForm } from './UpdateExpiryDateForm';

interface UpdateExpiryDateLoaderProps {
  seekAdvertiserId: string;
  jobId: string;
  onClose(): void;
}

export const UpdateExpiryDateFormLoader: React.FC<
  React.PropsWithChildren<UpdateExpiryDateLoaderProps>
> = (props) => {
  const { loading, error, expiryDate } = useQueryJobExpiryDate(
    props.seekAdvertiserId,
    props.jobId,
  );

  if (loading) {
    return <Loader />;
  }

  const formattedExpiryDate = expiryDate
    ? format(new Date(expiryDate), 'dd/MM/yyyy')
    : '';

  return (
    <UpdateExpiryDateForm
      {...props}
      expiryDate={formattedExpiryDate}
      getExpiryDateError={Boolean(error)}
    />
  );
};
